/**
 * Разбор сданного мока (20.10.2026): чистые помощники экрана — читаемый ответ,
 * выделение цитаты в отрывке, номер вопроса и время записи.
 *
 * Ответы ученика и ключи приходят в сыром виде сервера: `not_given`,
 * «A || B» у «выберите ДВА». Ученику показываем, как на экзамене.
 */

const ENUM_ANSWERS: Record<string, string> = {
  true: 'TRUE',
  false: 'FALSE',
  not_given: 'NOT GIVEN',
  yes: 'YES',
  no: 'NO',
};

/** Ответ в том виде, как на бланке экзамена. Пусто — пустая строка. */
export function readableAnswer(type: string, raw: string | undefined | null): string {
  const v = (raw ?? '').trim();
  if (!v) return '';
  if (type === 'true_false_ng' || type === 'yes_no_ng') {
    return ENUM_ANSWERS[v.toLowerCase()] ?? v;
  }
  if (type === 'mc_multi') {
    return v
      .split('||')
      .map((s) => s.trim())
      .filter(Boolean)
      .join('; ');
  }
  return v;
}

/** Номер вопроса: «7» или «21–22» у «выберите ДВА». */
export function questionNumber(ord: number, ordTo?: number | null): string {
  return ordTo && ordTo > ord ? `${ord}–${ordTo}` : String(ord);
}

/**
 * Отрывок, разбитый на «до / выделено / после» по границам из сервера (в
 * символах Unicode, как руны в Go). Кривые границы — без выделения, но
 * отрывок целиком: лучше показать текст, чем ничего.
 */
export function splitHighlight(context: string, start: number, end: number): [string, string, string] {
  const chars = Array.from(context);
  if (!(start >= 0 && end > start && end <= chars.length)) return [context, '', ''];
  return [chars.slice(0, start).join(''), chars.slice(start, end).join(''), chars.slice(end).join('')];
}

/** Время записи «2:05» из секунд. */
export function clock(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** С какого места включать запись: чуть раньше цитаты, чтобы услышать начало фразы. */
export function playFrom(sec: number): number {
  return Math.max(0, sec - 3);
}
